import { connect } from 'react-redux';
import ProjectFeedback from 'common/components/project_feedback';

const mapStateToProps = ({ user }) => {
  return {
    user: user.profile_data
  }
}

export default connect(mapStateToProps)(ProjectFeedback);



// WEBPACK FOOTER //
// ./common/containers/project_feedback.jsx